import styled, { css } from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

const required = css`
	&::after {
		content: '*';
		position: absolute;
		right: -14px;
		top: -2px;
	}
`;

export const FullLine = styled.div``;

export const LeftHalf = styled.div``;

export const RightHalf = styled.div``;

export const Separator = styled.hr`
	height: 1px;
	padding: 0;
	margin: 16px 0 0;
	border: none;
	width: 100%;
	background-color: #ced4da;
`;

export const SectionTitle = styled.div<{ $requiredToPublish?: boolean; $requiredToSave?: boolean }>`
	${({ theme }) => theme.typography.headlines.h5};
	width: max-content;
	position: relative;

	${({ $requiredToSave }) =>
		$requiredToSave &&
		css`
			${required};
		`}

	${({ $requiredToPublish }) =>
		$requiredToPublish &&
		css`
			${required};
			&::after {
				color: ${({ theme }) => theme.colors.neutral.red};
			}
		`}
`;

export const Label = styled.span`
	align-content: end;
`;

export const Field = styled.span``;

export const Form = styled.div`
	display: grid;
	grid-auto-rows: 24px minmax(50px, auto);
	padding: 16px 0 0;
	gap: 8px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		grid-auto-rows: minmax(50px, auto);
		grid-template-columns: 175px 1fr;
		gap: 12px;

		${Label} {
			align-content: center;
			grid-column: 1;
		}

		${Field} {
			grid-column: 2;
		}
	}
`;

export const MainForm = styled.div`
	display: grid;
	gap: 20px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;

export const Container = styled.div`
	display: grid;
	gap: 20px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		${FullLine} {
			grid-column: 1/3;
		}

		${MainForm} {
			grid-column: 1/3;
		}

		${LeftHalf} {
			grid-column: 1;
		}

		${RightHalf} {
			grid-column: 2;
		}
	}
`;

export const Acessories = styled.div`
	display: grid;
	grid-template-columns: 1;
	gap: 16px;
	padding-top: 16px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;

export const ButtonsWrapper = styled.div`
	padding: 16px;
	display: flex;
	justify-content: end;
	gap: 24px;
`;

export const Section = styled.div`
	background-color: ${({ theme }) => theme.colors.neutral.white};
	border-radius: 12px;
	padding: 16px;
	width: 100%;
	height: 100%;

	& ${SectionTitle}:not(:first-child) {
		margin-top: 20px;
	}
`;

export const VehicleImagesContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	padding-top: 16px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns: 1fr;
	}
`;

export const UploadImagesButton = styled.button`
	width: 100%;
	height: 240px;
	background-color: transparent;
	cursor: pointer;
	border: 2px dashed ${({ theme }) => theme.colors.primary.medium};
	border-radius: 12px;
	font-size: 48px;
	transition: background-color 0.3s;

	&:hover {
		background-color: ${({ theme }) => theme.colors.primary.lighter};
	}
`;

export const ImageContainer = styled.img`
	width: 100%;
	height: 240px;
	object-fit: cover;
	border-radius: 12px;
`;

export const ImageOverlay = styled.div`
	position: absolute;
	width: 100%;
	height: 240px;
	top: 0;
	border-radius: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	opacity: 0;
	transition: 0.3s;

	&:hover {
		opacity: 1;
		background-color: rgba(255, 255, 255, 0.5);
	}
`;

export const NotSynced = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 8px;
	right: 8px;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	color: ${({ theme }) => theme.colors.neutral.white};
	background-color: ${({ theme }) => theme.colors.primary.medium};
`;

export const InspectionReportContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-top: 16px;

	> div {
		display: flex;
		gap: 16px;
		align-items: center;
		color: ${({ theme }) => theme.colors.body.light};

		@media (max-width: ${DESKTOP_BREAKPOINT}px) {
			flex-direction: column;
			align-items: flex-start;
		}
	}
`;

export const ExternalLink = styled.a`
	display: flex;
	align-items: center;
	gap: 4px;
	color: ${({ theme }) => theme.colors.primary.medium};

	&:hover {
		color: ${({ theme }) => theme.colors.primary.light};
	}
`;

export const RequiredFields = styled.div`
	${({ theme }) => theme.typography.label.small};
	margin-top: 8px;
	display: flex;
	gap: 8px;
	justify-content: end;

	> span {
		display: inline-block;
	}

	span:nth-child(1) {
		color: ${({ theme }) => theme.colors.neutral.black};
	}

	span:nth-child(2) {
		color: ${({ theme }) => theme.colors.neutral.red};
	}
`;
